'use strict';

var _Object$create = require("@babel/runtime-corejs3/core-js-stable/object/create");

var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/map");

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");

require("core-js/modules/es.array.join.js");

require("core-js/modules/es.array.map.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/web.dom-collections.for-each.js");

var Helpers = require('./helpers');

module.exports.decodeValue = decodeValue;
module.exports.encodeValue = encodeValue;
module.exports.decode = decode;
module.exports.encode = encode;
var tokens_map = {
  '\\\\': '\\',
  '\\:': ';',
  '\\s': ' ',
  '\\n': '\n',
  '\\r': '\r',
  '\\': '' // remove invalid backslashes

};
var token_lookup = /\\\\|\\:|\\s|\\n|\\r|\\/gi;

function decodeValue(value) {
  return value.replace(token_lookup, function (m) {
    return tokens_map[m] || '';
  });
}

var vals_map = {
  '\\': '\\\\',
  ';': '\\:',
  ' ': '\\s',
  '\n': '\\n',
  '\r': '\\r'
};
var val_lookup = /\\|;| |\n|\r/gi;

function encodeValue(value) {
  return value.replace(val_lookup, function (m) {
    return vals_map[m] || '';
  });
}

function decode(tag_str) {
  var _context;

  var tags = _Object$create(null);

  _forEachInstanceProperty(_context = tag_str.split(';')).call(_context, function (tag) {
    var parts = Helpers.splitOnce(tag, '=');
    var key = parts[0].toLowerCase();
    var value = parts[1] || '';

    if (!key) {
      return;
    }

    value = decodeValue(value);
    tags[key] = value;
  });

  return tags;
}

function encode(tags) {
  var _context2;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ';';

  var parts = _mapInstanceProperty(_context2 = _Object$keys(tags)).call(_context2, function (key) {
    var val = tags[key];

    if (typeof val === 'boolean') {
      return key;
    }

    return key + '=' + encodeValue(val.toString());
  });

  return parts.join(separator);
}